export default {
  "bp-x-large": "1140px",
  "bp-large": "910px",
  "bp-medium": "780px",
  "bp-small": "680px",
  "bp-x-small": "470px",
};
